module.exports = __webpack_public_path__ + "static/media/arrow.b09fbefb.svg";